import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Common Code Management Service
 * !== 공통 코드 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/comnmdle/comncd`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/cd/comn-cd`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Code Management" }],
};

export const URLS = {
    osci0109001q: `${BASE.path}/osci0109001q`, // Common Code Management List !== 공통 코드 관리 목록 ==!
    osci0109002s: `${BASE.path}/osci0109002s`, // Common Code Registration !== 공통 코드 등록 ==!
    osci0109003q: `${BASE.path}/osci0109003q`, // Common Code Details !== 공통 코드 상세 ==!
    osci0109004s: `${BASE.path}/osci0109004s`, // Modifying Common Code !== 공통 코드 수정 ==!
    osci0109006s: `${BASE.path}/osci0109006s`, // Register Common Code Valid Values !== 공통 코드 유효 값 등록 ==!
    osci0109007q: `${BASE.path}/osci0109007q`, // Common Code Valid Value Details !== 공통 코드 유효 값 상세 ==!
    osci0109008s: `${BASE.path}/osci0109008s`, // Modifying Common Code Valid Values !== 공통 코드 유효 값 수정 ==!
};

export const APIS = {
    // View common code management list !== 공통 코드 관리 목록 조회 ==!
    getComnCdMstrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Common Code Management Inquiry !== 공통 코드 관리 조회 ==!
    getComnCdMstrInfo: (comnCd: any) => api.get(`${BASE.api}/${comnCd}`),

    // Save Common Code Management !== 공통 코드 관리 저장 ==!
    saveComnCdMstr: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Delete Common Code Management !== 공통 코드 관리 삭제 ==!
    deleteComnCdMstr: (comnCds: any) => {
        return api.delete(`${BASE.api}/${comnCds}`);
    },

    // Check Common Code Management Valid Values List !== 공통 코드 관리 유효 값 목록 조회 ==!
    getComnCdDtlList: (comnCd: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${comnCd}/dtl?page=${page}&size=${size}`);
    },

    // Common code valid value lookup !== 공통 코드 유효 값 조회 ==!
    getComnCdDtlInfo: (data: any) => api.get(`${BASE.api}/${data.comnCd}/dtl/${data.cdVldVal}`),

    // Save Common Code Valid Values !== 공통 코드 유효 값 저장 ==!
    saveComnCdDtl: (data: any) => {
        return api.post(`${BASE.api}/${data.comnCd}/dtl`, {
            ...data,
        });
    },

    // Delete Common Code Valid Values !== 공통 코드 유효 값 삭제==!
    deleteComnCdDtl: (comnCd: any, cdVldVals: any) => {
        return api.delete(`${BASE.api}/${comnCd}/dtl/${cdVldVals}`);
    },
};

// Common Code Management Search Form !== 공통 코드 관리 검색 폼 ==!
export const SF_COMN_CD_MGMT_MSTR_SRCH: TFormSchema = {
    id: "form_comnCdMstrSrch",
    schema: {
        comnCd: { type: "text", label: "L_COMN_CD", letterCase: "upper" },
        comnCdNm: { type: "text", label: "L_COMN_CD_NM" },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            defaultValue: "OSC",
        },
    },
};

// Common Code Management Form !== 공통 코드 관리 폼 ==!
export const SF_COMN_CD_MGMT_MSTR_INFO: TFormSchema = {
    id: "form_comnCdMstrInfo",
    schema: {
        comnCd: {
            type: "text",
            label: "L_COMN_CD",
            required: true,
            maxLength: 7,
            letterCase: "upper",
            pattern: { value: /^[A-Z]{3}[0-9]{4}$/, message: "msg.osc.00191" },
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            required: true,
            area: "comnCd",
            comnCd: "OSC0088",
            defaultValue: "OSC",
        },
        comnCdNmEn: { type: "text", label: "L_COMN_CD_NM_EN", required: true, maxLength: 200 },
        comnCdNmKo: { type: "text", label: "L_COMN_CD_NM_KO", required: true, maxLength: 200 },
        comnCdNmTz: { type: "text", label: "L_COMN_CD_NM_TZ", required: true, maxLength: 200 },
        comnCdDataLenVal: {
            type: "text",
            label: "L_COMN_CD_DATA_LEN_VAL",
            maxLength: 5,
            pattern: { value: /[0-9]$/, message: "msg.osc.00188" },
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            select: false,
            required: true,
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
        },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "text", label: "L_FRST_RGSR_DTM" },
    },
};

// Common Code Management Valid Value Form !== 공통 코드 관리 유효 값 폼 ==!
export const SF_COMN_CD_MGMT_DTL_INFO: TFormSchema = {
    id: "form_comnCdDtlInfo",
    schema: {
        comnCd: { type: "text", label: "L_COMN_CD", readOnly: true, maxLength: 7 },
        cdVldVal: { type: "text", label: "L_CD_VLD_VAL", required: true, maxLength: 30 },
        cdVldValNmEn: { type: "text", label: "L_CD_VLD_VAL_NM_EN", required: true, maxLength: 200 },
        cdVldValNmKo: { type: "text", label: "L_CD_VLD_VAL_NM_KO", required: true, maxLength: 200 },
        cdVldValNmTz: { type: "text", label: "L_CD_VLD_VAL_NM_TZ", required: true, maxLength: 200 },
        vldStrtDt: { type: "date", label: "L_VLD_STRT_DT", required: true },
        vldEndDt: { type: "date", label: "L_VLD_END_DT", required: true },
        srtngOrd: { type: "text", label: "L_SRTNG_ORD", maxLength: 10 },
        usrDefnVldVal1: { type: "text", label: "L_USR_DEFN_VLD_VAL1", maxLength: 30 },
        usrDefnVldVal2: { type: "text", label: "L_USR_DEFN_VLD_VAL2", maxLength: 30 },
        usrDefnVldVal3: { type: "text", label: "L_USR_DEFN_VLD_VAL3", maxLength: 30 },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            select: false,
            required: true,
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
        },
    },
};

// Common Code Management List Grid Schema !== 공통 코드 관리 목록 그리드 스키마 ==!
export const SG_COMN_CD_MGMT_MSTR_LIST: TGridSchema = {
    id: "grid_comnCdMgmtMstrList",
    options: { pagination: "out", index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: "10%" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "10%" }] },
        { cells: [{ header: "L_COMN_CD_NM_EN", binding: "comnCdNmEn", width: "*" }] },
        { cells: [{ header: "L_COMN_CD_NM_TZ", binding: "comnCdNmTz", width: "*" }] },
        { cells: [{ header: "L_COMN_CD_NM_KO", binding: "comnCdNmKo", width: "*" }] },
        { cells: [{ header: "L_COMN_CD_DATA_LEN_VAL", binding: "comnCdDataLenVal", width: "15%" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "comnCd", edit: false }] },
        { cells: [{ binding: "bsopClsfCd", edit: false }] },
        { cells: [{ binding: "comnCdNmEn", edit: false, align: "left" }] },
        { cells: [{ binding: "comnCdNmTz", edit: false, align: "left" }] },
        { cells: [{ binding: "comnCdNmKo", edit: false, align: "left" }] },
        { cells: [{ binding: "comnCdDataLenVal", edit: false, align: "right" }] },
        { cells: [{ binding: "useYn", edit: false }] },
    ],
};

// Common Code Management Valid Values List Grid Schema !== 공통 코드 관리 유효 값 목록 그리드 스키마 ==!
export const SG_COMN_CD_MGMT_DTL_LIST: TGridSchema = {
    id: "grid_comnCdMgmtDtlList",
    options: { pagination: "out", index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: 90, rowspan: 2 }] },
        { cells: [{ header: "L_CD_VLD_VAL", binding: "cdVldVal", width: 110, rowspan: 2 }] },
        {
            cells: [{ header: "L_CD_VLD_VAL_NM_EN", binding: "cdVldValNmEn", width: "*", rowspan: 2 }],
        },
        {
            cells: [
                { header: "L_CD_VLD_VAL_NM_TZ", binding: "cdVldValNmTz", width: "*" },
                { header: "L_CD_VLD_VAL_NM_KO", binding: "cdVldValNmKo", width: "*" },
            ],
        },
        {
            cells: [
                { header: "L_VLD_STRT_DT", binding: "vldStrtDt", width: 130 },
                { header: "L_VLD_END_DT", binding: "vldEndDt", width: 130 },
            ],
        },
        {
            cells: [
                { header: "L_SRTNG_ORD", binding: "srtngOrd", width: 80 },
                { header: "L_USE_YN", binding: "useYn", width: 80 },
            ],
        },
        {
            cells: [
                { header: "L_USR_DEFN_VLD_VAL1", binding: "usrDefnVldVal1", width: 180 },
                { header: "L_USR_DEFN_VLD_VAL2", binding: "usrDefnVldVal2", width: 180 },
            ],
        },
        { cells: [{ header: "L_USR_DEFN_VLD_VAL3", binding: "usrDefnVldVal3", width: 180, rowspan: 2 }] },
    ],
    body: [
        { cells: [{ binding: "comnCd", edit: false, rowspan: 2 }] },
        { cells: [{ binding: "cdVldVal", edit: false, rowspan: 2 }] },
        {
            cells: [{ binding: "cdVldValNmEn", edit: false, align: "left", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "cdVldValNmTz", edit: false, align: "left" },
                { binding: "cdVldValNmKo", edit: false, align: "left" },
            ],
        },
        {
            cells: [
                { binding: "vldStrtDt", edit: false, type: "date" },
                { binding: "vldEndDt", edit: false, type: "date" },
            ],
        },
        {
            cells: [
                { binding: "srtngOrd", edit: false, align: "right" },
                { binding: "useYn", edit: false },
            ],
        },
        {
            cells: [
                { binding: "usrDefnVldVal1", edit: false, align: "left" },
                { binding: "usrDefnVldVal2", edit: false, align: "left" },
            ],
        },
        { cells: [{ binding: "usrDefnVldVal3", edit: false, align: "left", rowspan: 2 }] },
    ],
};
